import {action, observable, computed, reaction, makeObservable} from 'mobx';
import {Search} from './Search';
import {Operator} from '../consts/operators';
import {Column} from '../../Form/serializers/column';

export class Filter {
    search: Search;
    column: Column;
    /** The field to filter by. */
    field: string;
    /** Filter operator */
    @observable operator: Operator;

    @observable value: any;

    @observable values: any[] = [];
    /** Specifies whether the returned rows should be sorted by this field, and the sort priority. */
    @observable issort: boolean = false;
    /** When sorting by this field, specify if the sort order is descending (true) or ascending (false). */
    @observable isdesc: boolean = false;

    @observable sortIndex: number;

    @observable isDirty: boolean = false;

    constructor(search, data) {
        makeObservable(this);
        //set bool column default value to true
        if (data.column && data.column.type === 'bool') {
            this.value = true;
        }

        Object.assign(this, data);
        this.search = search;

        //mark as dirty once "values" changes
        reaction(
            () => this.values.map(value => value),
            () => {
                this.isDirty = true;
            }
        );

        //mark as dirty once "value" changes
        reaction(
            () => this.value,
            () => {
                this.isDirty = true;
            }
        );

        //mark as dirty once the operator changes
        reaction(
            () => this.operator,
            () => {
                this.isDirty = true;
            }
        );
    }

    resetIsDirty() {
        this.setDirty(false);
    }

    @action setDirty(value: boolean) {
        this.isDirty = value;
    }

    @computed get isLast() {
        return this.search
            ? this.search.filterValues.indexOf(this) === this.search.filterValues.length - 1
            : true;
    }

    @computed get isEmpty() {
        //chnaged  "!this.value " to "this.value === undefined" in order to not ignore false value in boolean field
        if (this.value === undefined && !this.values.length) {
            return true;
        }

        if (this.operator === Operator.Between && !this.value?.max && !this.value?.min) {
            return true;
        }

        return false;
    }

    @action setOperator(operator) {
        this.operator = operator;
    }

    @action clearData() {
        this.values = [];
        this.operator = undefined;
    }

    @action setValue = value => {
        this.value = value;
    };

    @action setValues = values => {
        this.values = values;
    };

    @action addValue = value => {
        if (!this.isValueExists(value)) {
            this.values.push(value);
        }
    };

    @action toggleValue = value => {
        const index = this.values.indexOf(value);
        if (index >= 0) {
            this.removeValue(index);
        } else {
            this.addValue(value);
        }
    };

    @action removeValue = index => {
        this.values.splice(index, 1);
    };

    @action toggleSort = () => {
        this.issort = !this.issort;
        this.isdesc = false;
    };

    @action removeSort = () => {
        this.issort = false;
        this.isdesc = false;
    };

    @action toggleDesc = () => {
        this.isdesc = !this.isdesc;
    };

    isValueExists = value => {
        return this.values.indexOf(value) >= 0;
    };
}
